// Modules
import store from 'app-store';

// Constants
import { width, isMobile, rightPaneWidth, menuWidth, edgeThreshold } from 'constants';

// Action types
import * as types from './action-types';

// Opening right pane by swiping
export function openingRightPane(e, change) {
  const end = e.changedTouches[0].pageX;
  const delta = Math.abs(change);

  // Only open if we start within 100px of the right side of the screen
  if (end + delta < width - edgeThreshold) return;

  const offset = e.type === 'touchend' ? 0 : rightPaneWidth - delta;

  layoutSetting('rightPane.position', offset < 0 ? 0 : offset);
}

// Closing right pane by swiping
export function closingRightPane(e, change) {
  const delta = Math.abs(change);
  const offset = e.type === 'touchend' ? rightPaneWidth : delta;

  layoutSetting('rightPane.position', offset > rightPaneWidth ? rightPaneWidth : offset);
}

// Close the right pane
export function closeRightPane() {
  if (isMobile) {
    layoutSetting('rightPane.position', rightPaneWidth);
  } else {
    layoutSetting('rightPane.collapsed', true);
    setActiveTab();
  }
}

// Open the right pane
export function openRightPane(tab) {
  if (isMobile) {
    layoutSetting('rightPane.position', 0);
  } else {
    layoutSetting('rightPane.collapsed', false);
  }
  
  if (tab) setActiveTab(tab);
}

// Opening the menu by swiping
export function openingMenu(e, change) {
  const end = e.changedTouches[0].pageX;
  const delta = Math.abs(change);

  // Only open if we start within 100px of the left side of the screen
  if (end - delta > edgeThreshold) return;

  const offset = e.type === 'touchend' ? 0 : delta - menuWidth;

  layoutSetting('menu.position', offset > 0 ? 0 : offset);
}

// Closing the menu by swiping
export function closingMenu(e, change) {
  const delta = Math.abs(change);
  const move = e.type === 'touchend' ? menuWidth : delta;
  const offset = move > menuWidth ? menuWidth : move;

  layoutSetting('menu.position', offset * -1);
}

// Close the menu
export function closeMenu() {
  if (!isMobile) return;

  layoutSetting('menu.position', menuWidth * -1);
}

// Open the menu
export function openMenu() {
  if (!isMobile) return;

  layoutSetting('menu.position', 0);

  return false;
}

// Set the active tab
export function setActiveTab(tab) {
  layoutSetting('rightPane.activeTab', tab);
}

// Change setting
export function layoutSetting(path, value) {
  store.dispatch({ type: types.LAYOUT_SETTING, value, path });
}



// WEBPACK FOOTER //
// ./app/modules/page-layout/store/actions.js